export const resources_mobile_vertical = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            //
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/mobile_vertical/only_this_mode/hand.png",

            "res/mobile_vertical/utility_background.png",
            "res/mobile_vertical/frame_ui.png",
            "res/mobile_vertical/frame_total_bet.png",

            "res/mobile_vertical/back/background_0.jpg",
            "res/mobile_vertical/back/background_1.jpg",
            "res/mobile_vertical/back/background_2.jpg",
            "res/mobile_vertical/back/background_3.jpg",
            "res/mobile_vertical/back/background_4.jpg",
            "res/mobile_vertical/back/background_5.jpg",

            "res/mobile_vertical/fonts/font_gold_nums_mobile_vertical.xml",
            "res/mobile_vertical/fonts/font_white_nums_mobile_vertical.xml",
            "res/mobile_vertical/fonts/font_list_nums_mobile_vertical.xml",
            "res/mobile_vertical/fonts/font_credits_mobile_vertical.xml",
            "res/mobile_vertical/fonts/arial_regular_16_mobile_vertical.xml",
            "res/mobile_vertical/fonts/arial_regular_20_mobile_vertical.xml",
            "res/mobile_vertical/fonts/arial_bold_32_mobile_vertical.xml",
            "res/mobile_vertical/fonts/arial_regular_16_currency_mobile_vertical.xml",
            "res/mobile_vertical/fonts/font_coeff_mobile_vertical.xml",

            "res/mobile_vertical/utility_common.json",
            "res/mobile_vertical/select_light.json",
            "res/mobile_vertical/coin-0.json",
            "res/mobile_vertical/coin-1.json",
            "res/mobile_vertical/logo_jackpot.json",
            {name: "res/mobile_vertical/uiscene.json", rus: true},
            {name: "res/mobile_vertical/utility.json", rus: true},
            {name: "res/mobile_vertical/logo-0.json", rus: true},
            {name: "res/mobile_vertical/logo-1.json", rus: true}
        ]
};


//////////////////
// WEBPACK FOOTER
// ./res/mobile_vertical/resources.es6
// module id = 124
// module chunks = 0